<template>
  <!--操作栏-->
  <div class="action-baxr">
    <el-form
        :inline="true"
        :model="annouParam"
        label-width="55px"
        size="small">

      <el-form-item label="">
        <el-button type="primary"  @click="annouAction('add', {})">+新增导航广告</el-button>
      </el-form-item>

      <el-form-item label="名字">
        <el-input clearable   @clear="onSubmit" style="width: 110px" v-model="annouParam.name" placeholder="请输入名称"></el-input>
      </el-form-item>

      <el-form-item label="发布">
        <el-select
            style="width: 90px"
            v-model="annouParam.status"
            clearable
            @clear="onSubmit"
            placeholder="请选择"
        >
          <el-option label="上架中" :value="1"></el-option>
          <el-option label="已下架" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Banner">
        <el-select
            style="width: 90px"
            v-model="annouParam.banner"
            clearable
            @clear="onSubmit"
            placeholder="请选择"
        >
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="推荐">
        <el-select
            style="width: 90px"
            v-model="annouParam.pushFlag"
            clearable
            @clear="onSubmit"
            placeholder="请选择"
        >
          <el-option label="推荐" :value="1"></el-option>
          <el-option label="不推荐" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="有效期">
        <el-date-picker
            v-model="annouParam.time"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            :clearable="true"
            value-format="yyyy-MM-ddTHH:mm:ss+08:00"
            :default-time="['00:00:00', '23:59:59']"
        />
      </el-form-item>
      <el-form-item>
        <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click="onSubmit"
        >搜索
        </el-button
        >
      </el-form-item>
      <el-form-item>
        <div>点击总量：{{ sumCount || 0 }}</div>
      </el-form-item>
    </el-form>
    <!-- 表格数据 -->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading" size="small" ref="multipleTable">
      <el-table-column prop="title" label="标题" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.title || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="类型" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.type | typeRule }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="logo" label="Logo" align="center" min-width="80">
        <template slot-scope="scope">
          <img-load :width="'30px'" :key="scope.row.logo" :src="imgUrl +'/'+ scope.row.logo"></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="封面" align="center" min-width="80">
        <template slot-scope="scope">
          <img-load :width="'30px'" :key="scope.row.cover" :src="imgUrl +'/'+ scope.row.cover"></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="href" label="跳转地址" align="center" min-width="220" show-overflow-tooltip>
        <template slot-scope="scope">
          <a :href="scope.row.href" target="_blank"
             style="color:#67c23a;text-decoration: underline">{{ scope.row.href || '未知' }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="clicknum" label="点击数" align="center" min-width="90">
        <template slot-scope="scope">
          <span>{{ scope.row.clicknum || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sorted" label="排序" align="center" min-width="80">
        <template slot-scope="scope">
          {{ scope.row.sorted }}
        </template>
      </el-table-column>
      <el-table-column prop="position" label="布局" align="center" min-width="90">
        <template slot-scope="scope">
          <span>{{ scope.row.position === 1 ? "横排" : "宫格" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="pushFlag" label="推荐" align="center" min-width="90">
        <template slot-scope="scope">
          <span>{{ scope.row.pushFlag === 1 ? "推荐" : "不推荐" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="banner" label="Banner" align="center" min-width="90">
        <template slot-scope="scope">
          <span>{{ scope.row.banner === 1 ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" min-width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.status===1">上架</span>
          <span v-else>下架</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="updatedAt"
          min-width="360"
          label="有效期"
          align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.startTime | changeDate }} ~
          {{ scope.row.endTime | changeDate }}（{{ BeiJingTimePeriod(scope.row.endTime) }}）
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="operating" label="操作" align="center" min-width="300" fixed="right">
        <template slot-scope="scope">
          <el-button
              size="mini"
              icon="el-icon-edit"
              type="primary"
              @click="handleOpenStat(scope.row)"
          >下载明细</el-button>
          <el-button type="success" size="mini" class="el-icon-edit"     @click="annouAction('edit',scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" class="el-icon-delete" @click="remove(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[5, 15, 20, 30]" :current-page="annouParam.pageNumber"
                   :page-size="annouParam.pageSize"
                   layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 1"
                   @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑tag弹窗-->
    <annou-action ref="tagAction" @handlerAnnouList="getAnnouList()"></annou-action>
    <StatList  ref="statRef"></StatList>
  </div>
</template>
<script>
import API from '@/api'
import AnnouAction from './components/annouAction'
import baseConfig from '@/utils/serverUrlConfig'
import StatList from "./components/StatList";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      imgUrl: baseConfig.imgUrl,
      total: 0,
      sumCount: 0,
      // 公告列表请求参数
      annouParam: {
        pageNum: 1,
        pageSize: 15,
        name: "",
        status: '',
        pushFlag: '',
        position: '',
        banner: '',
        type: '',
        startTime: '',
        endTime: '',
        time:[]
      }
    }
  },
  components: {
    AnnouAction,
    StatList
  },
  filters: {
    typeRule: (value) => {
      if (value != 0 && !value) {
        return '未知'
      }
      let typeList = {
        1: '导航广告',
        2: '浮窗位置',
        3: '跑马灯',
        4: '评论公告',
      }
      return typeList[value] ? typeList[value] : '-'
    },
  },
  created() {
    this.getAnnouList()
  },
  methods: {
    BeiJingTimePeriod(params) {
      if (!params) {
        return "";
      }
      const selectedTime = new Date(params).getTime();
      const now = new Date().getTime();
      if (selectedTime > now) {
        return "正常";
      } else {
        return "已过期";
      }
    },
    handleOpenStat(row) {
      this.$refs.statRef.openDialog(row.id, row.title);
    },
    /**
     * 点击搜索按钮触发，并获取数据
     * @param {Null} 空
     * @return {Null} 空
     */
    onSubmit() {
      this.annouParam.pageNum = 1;
      this.annouParam.pageSize = 15;
      this.getAnnouList();
    },

    // 请求公告列表
    getAnnouList() {
      this.loading = true;
      if (this.annouParam.time && this.annouParam.time.length > 0) {
        this.annouParam.startTime = this.annouParam.time[0];
        this.annouParam.endTime = this.annouParam.time[1];
      }else{
        this.annouParam.startTime = "";
        this.annouParam.endTime = "";
      }
      API.queryList(this.annouParam).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
          this.sumCount = res.data.sumCount
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.annouParam.pageSize = size
      this.annouParam.pageNumber = 1
      this.getAnnouList()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.annouParam.pageNumber = pageNumber
      this.getAnnouList()
    },
    // 删除tags
    remove(id) {
      this.$confirm('您确定要删除当前公告吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            API.deleteItem({id}).then(res => {
              if (res.code === 200) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                })
                this.getAnnouList()
              } else {
                this.$message.error('删除失败，请重试')
              }
            })
          })
    },
    // 新增、删除tags
    annouAction(type, data) {
      this.$refs.tagAction.open(type, data);
    }
  }
}
</script>
<style lang="scss">
.views {
  font-size: 20px;
  color: #e63765;
  cursor: pointer;

  &:hover {
    color: #eb5f84;
  }
}

.edit {
  font-size: 18px;
  cursor: pointer;
  color: #e63765;
  vertical-align: middle !important;

  &:hover {
    color: #eb5f84;
  }
}

.cell {
  overflow: hidden;
}

.tags {
  font-size: 12px;
  margin-right: 5px;
}
</style>
